.signet-circular-loader {
  border-radius: 50%;
  border-style: solid;
  border-color: var(--primary-main);
  animation: circular-spinner-1 0.8s infinite linear alternate,
    circular-spinner-2 1.6s infinite linear;
}

.signet-circular-loader-xs {
  width: 20px;
  height: 20px;
  border-width: 2px;
}

.signet-circular-loader-sm {
  width: 30px;
  height: 30px;
  border-width: 4px;
}

.signet-circular-loader-md {
  width: 40px;
  height: 40px;
  border-width: 5px;
}

.signet-circular-loader-lg {
  width: 50px;
  height: 50px;
  border-width: 6px;
}

.signet-circular-loader-xl {
  width: 70px;
  height: 70px;
  border-width: 7px;
}

@keyframes circular-spinner-1 {
  0% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
  }

  12.5% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 0%,
      100% 0%,
      100% 0%
    );
  }

  25% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      100% 100%,
      100% 100%
    );
  }

  50% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }

  62.5% {
    clip-path: polygon(
      50% 50%,
      100% 0,
      100% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }

  75% {
    clip-path: polygon(
      50% 50%,
      100% 100%,
      100% 100%,
      100% 100%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }

  100% {
    clip-path: polygon(
      50% 50%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      0% 100%
    );
  }
}

@keyframes circular-spinner-2 {
  0% {
    transform: scaleY(1) rotate(0deg);
  }

  49.99% {
    transform: scaleY(1) rotate(135deg);
  }

  50% {
    transform: scaleY(-1) rotate(0deg);
  }

  100% {
    transform: scaleY(-1) rotate(-135deg);
  }
}
